/**
 * @fileoverview Vuex state
 * @module store/state
 * @see module:store/state
 */
import { LOCAL_STORAGE_KEY, DEFAULT_REALM } from '@/constants';
import { getStorageAuthInfo, storage } from '@/utils/storageOperateApi';
import { getSearchHint } from '@/utils/globalSearchMind';
const localAuthInfo = getStorageAuthInfo();

export const stateTemplate = {
  taskCenterActiveName: 'aiAssistant',
  uploadList: [],
  downloadList: [],
  taskPanel: false,
  tooltips: false,
  // 全局搜索联想词相关信息
  globalSearchHint: getSearchHint(),
  // 搜索唯一标识Map
  globalSearchIdMap: storage.get(LOCAL_STORAGE_KEY.GLOBAL_SEARCH_ID_MAP) || {},
  // 提示条内容
  ttText: '',
  // 用户信息
  userInfo: null,
  goId: 0,
  // 用户鉴权信息
  authUserInfo: null,
  // 用户开通会员信息
  userMembership: [],
  // 下载进度
  downloadProgress: [],
  // 导航收缩传递监听事件
  eventList: null,
  // 投研平台面包屑最后一项
  breadcrumb: {
    title: '',
    path: ''
  },
  // 地区/国家区号
  areaCodeOptions: [],
  containerSize: {
    height: 'auto',
    width: 'auto'
  },
  // 机构logo
  orgLogo: '',
  // 菜单折叠后展示的logo
  orgMiniLogo: '',
  // 机构信息
  orgInfo: null,
  // 用户头像
  userAvatar: storage.get(LOCAL_STORAGE_KEY.JM_AUTH_INFO, true)?.avatarurl || '',
  // 菜单是否收缩
  menuIsCollapse: true,
  // 缓存的页面
  keepAlive: [],
  // 缓存的页面是否需要刷新
  keepAliveNeedRefresh: false,
  // 分析师主页抽屉显示
  analystVisible: false,
  // 分析师uid
  analystUid: '',
  // 分析师信息
  analystInfo: {},
  // 合作方信息
  bridgeInfo: null,
  dataSync: {},
  queryingSync: null,
  // electron 窗口tab集合
  electronTabs: [],
  // 显示路演详情
  showLive: false,
  /** 异常用户安全认证 手机号/邮箱 **/
  securityAuth: false,
  securityAuthType: '',
  securityAuthContent: '',
  securityAuthCloseBtn: new Function(),
  securityAuthSuccessBtn: new Function(),
  /** 用户异常校验 人脸核身 **/
  securityFace: false,
  securityFaceType: '',
  securityFaceCloseBtn: new Function(),
  securityFaceSuccessBtn: new Function(),

  aiChatSetting: {},
  defaultAiChatSetting: {
    model: 'DEEPSEEK',
    useSearch: 1,
    infoCardCollapsed: 1
  },
  dialogIframe: {
    visible: false,
    url: '',
    urlCode: '',
    showQrCode: false,
    callback: null
  },
  // 支付弹窗
  webPayDialog: {
    visible: false,
    props: {}
  },
  // 牛币充值弹窗（全局唤起，与 webPayDialog 用法类似；pendingPaySuccess 用于支付成功后仍保留壳层直到成功弹窗关闭）
  nbiRechargeDialog: {
    visible: false,
    pendingPaySuccess: false,
    timestamp: 0,
    /** @type {null | (() => void | Promise<void>)} 支付成功后由 CustomNbiRecharge 调用一次并清空 */
    onSuccess: null
  },
  // 牛币明细弹窗（全局唤起，只读展示，供头像卡片 / 会员专区等入口直接打开，不涉及支付与宿主代理）
  nbiDetailDialog: {
    visible: false
  },
  // 会员/牛币付费弹窗代理给宿主（仅嵌入 iframe 且宿主声明支持时启用）
  // enabled 为 true 时，App.vue 不渲染本地会员/牛币弹窗，改为 postMessage 请求宿主处理
  memberDelegate: {
    enabled: false,
    /** @type {string} 宿主 origin，用于 postMessage target 与回包 origin 校验；空串表示未知 */
    hostOrigin: ''
  },
  aiAvatarListFilter: null,

  // 是否登录态 默认 登录
  isLogin: true,
  lang: '',
  isRecording: false,
  // 多文件上传管理（使用 Map 存储每个文件的上传任务）
  uploadTasks: {}, // { [fileId]: { ossClient, checkpoint } }
  // IRM 公司信息（iframe 场景下路由跳转后 query 会丢失，持久化到 store）
  irmCompanyInfo: {
    irmCompanyId: '',
    irmCompanyName: '',
    irmMarket: '',
    irmStockCode: '',
    irmFullCode: '',
    irmToken: ''
  },
  // AI聊天首页发送参数
  chatHomeSendParams: null,
  hiddenFeartByOrg: true,
  overseasUserPlan: '',
  // 海外版订阅信息（完整数据）
  overseasMemberData: null
};

// 深拷贝state template
const state = JSON.parse(JSON.stringify(stateTemplate));

// 初始化state
const initState = () => {
  state.userInfo = localAuthInfo ? localAuthInfo.userInfo : null;
  state.goId = storage.get(LOCAL_STORAGE_KEY.REALM_KEY) || DEFAULT_REALM;
  state.authUserInfo = localAuthInfo;
  state.userAvatar = storage.get(LOCAL_STORAGE_KEY.JM_AUTH_INFO, true)?.avatarurl || '';
};
initState();

export default state;
